import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Device } from '@era/locations-sdk';

@Component({
  selector: 'era-device-os-update-continue-ui',
  templateUrl: './device-os-update-continue.component.html',
  styleUrls: ['./device-os-update-continue.component.scss'],
})
export class DeviceOsUpdateContinueComponent {
  @Input() public device: Device;
  @Output() public readonly continueClicked = new EventEmitter<Device>();

  public onContinue() {
    this.continueClicked.emit(this.device);
  }
}
